import { IGroupUpdateRequestParams } from "interfaces";
import { GroupService } from "api/services/groups";

export function homePageActivated(groupData: any) {
    return (
        groupData &&
        groupData.home_page_config &&
        groupData.home_page_config.status
    )
}

export function membersAdded(groupData: any) {
    return groupData && groupData.members_count >= 2;
}

export function channelCreated(groupData: any) {
    if (groupData && groupData.channels && groupData.channels.length === 1) {
        return groupData.channels[0].id !== groupData.default_channel.id;
    }
    return groupData && groupData.channels && groupData.channels.length > 1;
}

export function contentPublished(groupData: any) {
    return groupData && (groupData.published_library_contents_count > 0 || groupData.published_courses_count > 0);
}

export function coursesPublished(groupData: any) {
    return groupData && groupData.published_courses_count > 0;
}

export function libContentPublished(groupData: any) {
    return groupData && groupData.published_library_contents_count > 0;
}

export function membershipSubscriptionSetup(groupData: any) {
    if (groupData && groupData.plans.length === 1) {
        return groupData.plans[0].price !== 0;
    }
    return groupData && groupData.plans.length > 1;
}


export function userProfileCompleted(groupData: any) {
    const userprofile =
        groupData && groupData.user_membership
            ? groupData.user_membership.user
            : null;
    if (userprofile) {
        return (
            userprofile.profile_image !== null &&
            userprofile.country !== null &&
            userprofile.timezone !== null &&
            userprofile.about_me !== null &&
            userprofile.location !== null
        );
    }
    return false;
}

export function userProfileImageAdded(groupData: any) {
    if (groupData) {
        return (
            groupData.user_membership &&
            groupData.user_membership.user.profile_image !== null
        );
    }
    return false;
}

export function adminProfileCompleted(groupData: any) {
    return userProfileCompleted(groupData) && userProfileImageAdded(groupData);
}

export function publishedEvents(groupData: any) {
    return groupData && parseInt(groupData.published_events_count) > 0
}

export const groupDataUpdate = (groupData: any, itemToUpdate: any) => {
    const payload: Partial<IGroupUpdateRequestParams> = { ...itemToUpdate };

    return GroupService.getInstance()
        .updateGroup(
            groupData && groupData.user_membership.user.id,
            groupData && groupData.id,
            payload
    ).then((response: any) => {
        return response.data;
    }).catch((error: any) => {
        console.error(error);
        return groupData;
    });
};

export function productTourWatched(groupData: any) {
    return groupData && groupData.product_tour_watched;
}
export function calendarBooked(groupData: any) {
    return groupData && groupData.onboarding_call_set;
}

export function customizeBranding(groupData: any) {
    return groupData && groupData.branding_customized;
}

export function invitePageConfigured(groupData: any) {
    return groupData && groupData.has_invite_page_configured;
}

export function customizeCommunitySettings(groupData: any) {
    return groupData && (groupData.branding_customized || groupData.timezone_id || groupData.profile_image || groupData.favicon_image);
}